import { httpClient } from '../http/httpClient'

export interface AvailableInfo {
  updatedAt: string
  queryAt?: string
  amount?: number
  isAutorized?: boolean
  isContacted?: boolean
  isArchived?: boolean
  schedule?: string
  seller?: string
}

export interface SellerInfo {
  _id: string
  name: string
  profileImageUrl: string
  cpf: string
}

export interface Consult {
  _id: string
  name: string
  cpf: string
  available: AvailableInfo
  lastTransaction?: string
  seller?: SellerInfo
}

export interface ConsultsResponse {
  data: Consult[]
  pagination: {
    skip: number
    limit: number
    sort: string
    total: number
    order: string
  }
}

export interface GetAllConsultsParams {
  search?: string
  limit?: number
  skip?: number
  sort?: string
  order?: '1' | '-1'
  sellerId?: string
}

export async function getAllConsults(params?: GetAllConsultsParams) {
  const { data } = await httpClient.get<ConsultsResponse>('/consults', {
    params,
  })

  return data
}
